import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth.service';

/**
 * Appends the Bearer token to all requests if authenticated.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.accessToken();
  const isAuthEndpoint =
    req.url.endsWith('/login') || req.url.endsWith('/signup') || req.url.endsWith('/refresh');

  // Don't add token to login/signup/refresh calls
  if (token && !isAuthEndpoint) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(req);
};
